import './UserMediaError.css';
import React from 'react';
import { pageAtom, myNftAtom } from '../../State';
import { useRecoilState } from 'recoil';
import isElectron from '../../Global';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
export default function UserMediaError() {
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const { t } = useTranslation();

  //ページをリロード
  const refreshPage = () => {
    window.location.reload();
  };

  //アプリを再起動
  const restart = async () => {
    await window.myapi.restart();
  };

  //背景をタップ時
  const tapBack = () => {
    // setPageState('main');
  };

  return (
    <>
      {/* NFTリスト　*/}
      <div id="backWrap" className="mediaErrorBack" onClick={tapBack}></div>
      <div id="mediaErrorWrap" style={{ height: '450px' }}>
        <div id="nftTitle">{t('haircheck.Error to detect your device')}</div>

        {isElectron && (
          <div id="mediaErrorBody">
            <div id="mediaErrorTitle">
              {t('haircheck.Allow access to microphone or/and camera')}
            </div>

            <div className="mediaError">
              1. {t('haircheck.Go to "System" setting and "Security and privacy"')}
            </div>
            <div className="mediaError">
              2. {t('haircheck.Check camera and microphone permission')}
            </div>
            <div className="mediaError">3. {t('haircheck.Restart the app ')}</div>
            <div style={{ textAlign: 'center', marginTop: '2em' }}>
              <button onClick={restart} type="submit" id="mediaRefresh">
                {t('haircheck.Restart')}
              </button>
            </div>
          </div>
        )}

        {isMobile && (
          <div id="mediaErrorBody">
            <div id="mediaErrorTitle" className="lessColor">
              {t('haircheck.Allow access to microphone')}
            </div>

            <div className="mediaError">
              1. {t("haircheck.Click the key lock icon in your browser's address bar.")}
            </div>
            <div className="mediaError">2. {t('haircheck.Activate microphone')} </div>
            <div className="mediaError">3. {t('haircheck.Refresh Page')} </div>
            <div style={{ textAlign: 'center', marginTop: '2em' }}>
              <button onClick={refreshPage} type="submit" id="mediaRefresh">
                {t('haircheck.Refresh Page')}
              </button>
            </div>
          </div>
        )}

        {isMobile == false && isElectron == false && (
          <div id="mediaErrorBody">
            <div id="mediaErrorTitle" className="lessColor">
              {t('haircheck.Allow access to microphone or/and camera')}
            </div>
            <div id="mediaErrorExplain">
              {t(
                'haircheck.* please make sure your microphone is connected before doing following step',
              )}
            </div>
            <div className="mediaError">
              1. {t("haircheck.Click the key lock icon in your browser's address bar.")}
            </div>
            <div className="mediaError">2. {t('haircheck.Activate microphone or/and camera')} </div>
            <div className="mediaError">3. {t('haircheck.Refresh Page')} </div>
            <div style={{ textAlign: 'center', marginTop: '2em' }}>
              <button onClick={refreshPage} type="submit" id="mediaRefresh">
                {t('haircheck.Refresh Page')}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
